import { ORGANIZATIONS_API, ORGANIZATION_LINKS_API } from "../../../Utilities/APIs";
// import PcBLNSCRUD from "../../Partials/Layouts/CRUDs/CRUDLayouts/BLNSCRUD/PcBLNSCRUD";
import PcBLSTsCRUD from "../../Partials/Layouts/CRUDs/CRUDLayouts/BLSTsCRUD/PcBLSTsCRUD";

function PcOrganizationLinks() {
  return (
    <PcBLSTsCRUD
        // parentChild props
        parentDBField={'organization'}
        
        // common props
        api={ORGANIZATION_LINKS_API}
        screenTopicSingular={'Organization Link'}
        screenTopicPlural={'Organization Links'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete

        //boolean props
        booleanDBField={'isVisible'}
        booleanName={'Is Visible'}
        
        // select props
        selectApi={ORGANIZATIONS_API}
        selectType={'parent-child'}
        selectDBField={'organization'}
        selectName={'Organization'}

        textSelectField='name'
        textSelectOptions={['website', 'facebook', 'youtube', 'instagram']}
        textSelectName='Organization Link'
    />
  )
}

export default PcOrganizationLinks